import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { clientMutation, clientQuery } from '../../../../../../../config/helpers/GraphQLApi';

import { endpoints } from '../../../../../../../config/constants';
import { ExceptionManager } from '../../../../../../../config/helpers/Logging'
import { resetALL } from '../../../../../../../config/redux/actions'

//STATE INITIAL
const INIT_STATE = {
    loading: false,
    data: null,
    result: null,
    errorResult: null,
    error: null,
    updatingAccess: false,
};

const route = 'modules/client/dashboard/views/detailTeam/slice'

//Extend async Action
export const teamAnnouncementDetailGetById = createAsyncThunk('dashboard/teamAnnouncementDetailGetById', async (
    { id },
    { rejectWithValue, dispatch }
) => {
    try {
        let data = await clientQuery(
            `query getTeamAnnouncementById($id: Int!){
                result: getTeamAnnouncementById(announcementId: $id) {
                    id
                    status
                    lastStatus {
                        status
                        updatedOn
                        user {
                            firstName
                            lastName
                        }
                    }
                    announcement {
                        id
                        product
                        name
                        title
                        max_price
                        description
                        date
                        request_type
                        looking_for
                        looking_for2
                        inspection
                        codicemd5
                        id_comuna
                        phone
                        email
                        contact_time
                        surname
                        definition
                        comuna_name
                        province_name
                    }
                    restrictionAccess {
                        agents {
                            email
                            userId
                            fullName
                            hasAccess
                            companyName
                        },
                        affiliatedPartners {
                            email
                            userId
                            fullName
                            hasAccess
                            company {
                                name
                            }
                        },
                        areaManagers {
                            email
                            userId
                            fullName
                            hasAccess
                            companyName
                        }
                    }
                }
            }`,
            {
                id: parseInt(id, 10),
            },
            endpoints.GRAPHQL_GENERAL
        );
        if(data?.result)
            return data.result
        else
            throw "Error: no tienes acceso"
    } catch (exc) {
        ExceptionManager(exc, route, 'teamAnnouncementDetailGetById', dispatch);
        return rejectWithValue(exc)
    }
})

export const updateViewTeamAnnouncement = createAsyncThunk('dashboard/updateViewTeamAnnouncement', async (
    { id, viewType },
    { rejectWithValue, dispatch }
) => {
    try {
        let data = await clientMutation(
            `mutation updateViewsTeamAnnouncement($id: Int, $viewType: enumViewType){
                result: updateViewsTeamAnnouncement(id: $id, viewType: $viewType) 
            }`,
            {
                id: parseInt(id, 10),
                viewType
            },
            endpoints.GRAPHQL_GENERAL
        );

        if(data?.result)
            return data.result
        else
            throw "Error: no tienes acceso"
    } catch (exc) {
        ExceptionManager(exc, route, 'updateViewTeamAnnouncement', dispatch);
        return rejectWithValue(exc)
    }
})

export const updateAccess = createAsyncThunk('dashboard/updateAccess', async (
    { id, userId, hasAccess },
    { rejectWithValue, dispatch }
) => {
    try {
        let data = await clientMutation(
            `mutation updateRestrictionAccessTeamAnnouncement($id: Int, $userId: Int, $hasAccess: Boolean){
                result: updateRestrictionAccessTeamAnnouncement(teamAnnouncementId: $id, userId: $userId, hasAccess: $hasAccess) 
            }`,
            {
                id: parseInt(id, 10),
                userId,
                hasAccess
            },
            endpoints.GRAPHQL_GENERAL
        );

        if(data?.result)
            return data.result
    } catch (exc) {
        ExceptionManager(exc, route, 'updateViewTeamAnnouncement', dispatch);
        return rejectWithValue(exc)
    }
})
//Slice
const teamAnnouncementDetailRedux = createSlice({
    name: 'dashboard/teamAnnouncementDetailRedux',
    initialState: INIT_STATE,
    reducers: {
        reset(state, action) {
            return action.payload ? { ...state, ...action.payload } : { ...INIT_STATE }
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetALL, () => INIT_STATE)

        builder.addCase(teamAnnouncementDetailGetById.pending, (state) => {
            state.loading = true
        })
        builder.addCase(teamAnnouncementDetailGetById.fulfilled, (state, { payload }) => {
            state.loading = false
            state.data = payload
        })
        builder.addCase(teamAnnouncementDetailGetById.rejected, (state, {payload}) => {
            state.loading = false
            state.error = payload.error
        })

        builder.addCase(updateViewTeamAnnouncement.pending, (state) => {
            state.loading = true
        })
        builder.addCase(updateViewTeamAnnouncement.fulfilled, (state) => {
            state.loading = false
            //state.data = payload
        })
        builder.addCase(updateViewTeamAnnouncement.rejected, (state, action) => {
            state.loading = false
            state.resultError = action.error
        })

        builder.addCase(updateAccess.pending, (state) => {
            state.updatingAccess = true
        })
        builder.addCase(updateAccess.fulfilled, (state) => {
            state.updatingAccess = false
        })
        builder.addCase(updateAccess.rejected, (state, action) => {
            state.updatingAccess = false
            state.resultError = action.error
        })
    },
})

// Extract and export the action creators object and the reducer
export const { actions, reducer } = teamAnnouncementDetailRedux

// Extract and export each action creator by name
export const { reset } = actions

//Simple async action

// Export the reducer, either as a default or named export
export default reducer